<template>
  <v-card>
    <v-card-title primary-title>
      Completed by
        {{ createdBy }} at
        {{ formatDateTime(created) }}
    </v-card-title>
    <v-card-actions>
      <pin-dialog label="Approve" />
      <div class="mr-10" />
      <pin-dialog label="Review" />
    </v-card-actions>
  </v-card>
</template>

<script>
import PinDialog from './PinDialog.vue';

export default {
  props: ['created', 'createdBy'],
  components: {
    PinDialog,
  },
};
</script>
